<template>
    <div class="b-table-header" wrap>
        <div :class="headerSlotClass">
            <div class="vstack gap-2">
                <div class="hstack">
                    <slot name="headerTopBar"></slot>
                </div>
                <div class="hstack gap-2">
                    <slot name="default"></slot>
                    <div class="hstack gap-2 ms-auto" v-if="value">
                        <slot name="pagingStart"></slot>
                        <nav :aria-label="navLabel || 'Pagination'">
                            <pagination-default :header-slot-class=headerSlotClass :value="value" :announce="announce" @option-change="handleOptionChange" v-if="value.pagingMode == 'withTotal'"/>
                            <pagination-no-last-or-total :header-slot-class=headerSlotClass :value="value" :is-previous-disabled="value.page == 1" :is-next-disabled="isNextDisabled" :filters="props.filters" :announce="announce" @option-change="handleOptionChange" :current-item-count="props.currentItemCount" v-else />
                        </nav>
                    </div>
                </div> 
            </div>
            
        </div>        
    </div>
</template>
<script setup lang="ts">
    import { ref, watch, onMounted } from 'vue';
    import { BTableOptions } from "./BTable.types";
    import PaginationDefault from "@/components/Pagination/PaginationDefault.vue";
    import PaginationNoLastOrTotal from "@/components/Pagination/PaginationNoLastOrTotal.vue";

    const emits = defineEmits(['optionChange']);

    const props = withDefaults(defineProps<{
    value: BTableOptions | null,
    headerSlotClass?: string,
    currentItemCount?:number,
    filters?:BFilter[],
    announce?: boolean,
    navLabel?: string
    }>(), {
        headerSlotClass: '',
        filters: [],
        announce: false
    });

    var options = ref(props.value as BTableOptions);

    var isNextDisabled = ref(false);

    function handleOptionChange(newOptions){
        options.value = newOptions;
        emits("optionChange", options.value);
    }

    function setNextButtonState(){
        if (props.currentItemCount && options.value) {
            isNextDisabled.value = props.currentItemCount <= options.value.itemsPerPage;
        }
    }

    watch(
    () => props.currentItemCount,
    (val) => {
        setNextButtonState();
    });

    onMounted(() => {
        setNextButtonState();      
    });

</script>
<style lang="scss">
.b-table-header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    // align-items: baseline;
    justify-content: flex-end;
}
.b-table-header-controls {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    // flex-direction: row-reverse;
}
.b-table-header-info {
    margin-right: 20px;
    text-align: right;
}
.b-table-header-pagesize {
    margin: 0 20px;
    width: 75px;
}
</style>

